import React from 'react';

interface Step {
  number: number;
  title: string;
  description: string;
}

interface CheckoutStepsProps {
  steps: Step[];
  currentStep: number;
}

const CheckoutSteps: React.FC<CheckoutStepsProps> = ({ steps, currentStep }) => {
  return (
    <div className="mb-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="relative">
          <div className="flex items-center justify-between">
            {steps.map((step, index) => (
              <React.Fragment key={step.number}>
                <div className="flex flex-col items-center">
                  {/* Step Number Circle */}
                  <div className="relative">
                    <div className={`
                      flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 text-sm font-semibold
                      ${currentStep > step.number
                        ? 'bg-green-500 border-green-500 text-white'
                        : currentStep === step.number
                        ? 'bg-primary-navy border-primary-navy text-white'
                        : 'bg-white border-gray-300 text-gray-400'
                      }
                    `}>
                      {currentStep > step.number ? (
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      ) : (
                        step.number
                      )}
                    </div>
                    
                    {/* Active Step Ring */}
                    {currentStep === step.number && (
                      <div className="absolute -inset-1 rounded-full border-2 border-primary-navy opacity-30 animate-pulse"></div>
                    )}
                  </div>
                  
                  {/* Step Label */}
                  <div className="mt-3 text-center min-w-0 max-w-[120px]">
                    <div className={`text-sm font-medium transition-colors duration-200 ${
                      currentStep >= step.number ? 'text-gray-900' : 'text-gray-500'
                    }`}>
                      {step.title}
                    </div>
                    <div className={`text-xs mt-1 transition-colors duration-200 ${
                      currentStep >= step.number ? 'text-gray-600' : 'text-gray-400'
                    }`}>
                      {step.description}
                    </div>
                  </div>
                </div>
                
                {/* Connector Line */}
                {index < steps.length - 1 && (
                  <div className="flex-1 mx-4 mt-[-30px]">
                    <div className={`h-[2px] transition-all duration-300 ${
                      currentStep > step.number ? 'bg-green-500' : 'bg-gray-200'
                    }`}></div>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSteps;